import { render, staticRenderFns } from "./FmaListing.vue?vue&type=template&id=03230648&scoped=true"
import script from "./FmaListing.vue?vue&type=script&lang=js"
export * from "./FmaListing.vue?vue&type=script&lang=js"
import style0 from "./FmaListing.vue?vue&type=style&index=0&id=03230648&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03230648",
  null
  
)

export default component.exports